import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomeTwo from "./pages/home-2";

import Faq from "./pages/faq";
import NoPage from "./pages/NoPage";
import Gallery from "./pages/gallery";
import GalleryDetails from "./pages/gallery-details";
import Event from "./pages/event";
import EventDetails from "./pages/event-details";
import Contact from "./pages/contact";
import Privacy from "./pages/privacy";
import MesTickets from "./pages/mes-tickets";
import MesTicketsAuth from "./pages/mes-tickets/Auth";
import MesTicketsListe from "./pages/mes-tickets/Liste";
import References from "./pages/references";
import ScrollToTop from "./components/elements/ScrollToTop";




export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route index element={<HomeTwo />} />
        <Route path="accueil" element={<HomeTwo />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="gallery-details" element={<GalleryDetails />} />
        <Route path="faq" element={<Faq />} />
        <Route path="terms-and-conditions" element={<Privacy />} />
        <Route path="privacy" element={<Navigate to="/terms-and-conditions" replace />} />
        <Route path="events" element={<Event />} />
        <Route path="references" element={<References />} />
        {/* <Route path="événements" element={<Event />} /> */}
        <Route path="contact" element={<Contact />} />
        <Route path="mes-tickets" element={<MesTickets />} />
        <Route path="mes-tickets/auth" element={<MesTicketsAuth />} />
        <Route path="mes-tickets/liste" element={<MesTicketsListe />} />
        <Route path=":slug/preview/:previewToken" element={<EventDetails />} />
        <Route path="preview/:previewToken" element={<EventDetails />} />
        <Route path="event-details/:id" element={<EventDetails />} />
        <Route path=":slug" element={<EventDetails />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}
